<template>
  <section class="story">
    <transition name="fade">
      <div class="story-modal" v-if="modalOpened">
        <div class="story-modal-content">
          <a class="story-modal-close" @click="() => (modalOpened = false)"
            >&times;</a
          >
          <iframe
            width="100%"
            height="350"
            src="https://www.youtube.com/embed/jxD7hNHj_j0"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </transition>
    <div class="story-overlay">
      <div class="story-content">
        <!-- coloquei aqui por causa do SEO -->
        <h1>Conheça Crivelli Advogados</h1>
        <!-- <h2>Conheça nossa história de 35 anos</h2> -->
        <p>
          A Crivelli Advogados Associados conta com mais de 35 anos de
          experiência, sempre pautada por um posicionamento de vanguarda na
          advocacia, alicerçada no objetivo de construir uma sociedade mais
          justa e igualitária. Nossa marca é um compromisso de se reinventar
          todo dia para oferecer uma advocacia diferenciada, técnica, combativa
          e crítica à altura dos desafios das novas tecnologias para a advocacia
          e para o mundo do trabalho.
        </p>
        <div class="story-buttons">
              <router-link
                  :to="{ name: 'page_about' }"
                  class="button button-orange"
                  >VER HISTÓRIA</router-link
                >
          <a
            @click.prevent="() => (modalOpened = true)"
            class="button button-orange is-transparent is-outlined"
          >
            <span>ASSISTIR VÍDEO</span>
            <video-icon width="20" class="icon right" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VideoIcon from "../../components/Svg/VideoIcon";
export default {
  components: {
    VideoIcon,
  },

  data() {
    return {
      modalOpened: false,
    };
  },
};
</script>

<style>
</style>
